<template>
  <drawer-head subTitle="更新记录"></drawer-head>
</template>
<script>
import DrawerHead from "@components/frontline/DrawerHead";
export default {
  name: "UpdateRecord",
  components: {
    DrawerHead,
  },
};
</script>
